import {analytics} from '../globals/config';

/**
 * Dealer data reference, set externally to avoid circular dependency.
 * @type {object|null}
 */
let _garageLocatorDataRef = null;

/**
 * Set the garageLocatorData reference for dealer info enrichment.
 * Called once from garageLocator module during init.
 */
export function setGarageLocatorDataRef(ref) {
    _garageLocatorDataRef = ref;
}

export default function (step, option = null, stepNum = null, requestType = null) {
    const eventData = steps[step];
    const impressionData = impressionSteps[step];

    if (option) {
        eventData.info.toolStepOption = option;
    }

    if (stepNum) {
        eventData.info.toolStepNumber = stepNum;
    }

	if (requestType) {
		eventData.info.requestType = requestType;

		if (requestType === 'quote') {
			eventData.info.toolName = 'wonderservice-quote';
		}

		if (requestType === 'appointment') {
			eventData.info.toolName = 'wonderservice-appointment';
		}

	}

    // Enrich with dealer information when available
    if (_garageLocatorDataRef && _garageLocatorDataRef.garageID) {
        eventData.info.dealerID = _garageLocatorDataRef.garageID;
        eventData.info.dealerName = _garageLocatorDataRef.name || '';
    }

    if (eventData) {
        if (impressionData) {
            handleImpressions(step);
        }

        analytics.trackEvent(eventData);
    } else {
        console.error(`No event data found for step: ${step}`);
    }
}

const steps = {
	// Online Diagnosis
	'online-diagnosis-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'online-diagnosis',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 1,
		},
	},
	'online-diagnosis-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'online-diagnosis',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 1,
		},
	},

	// Issue
	'issue-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'issue',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2,
		},
	},
	'issue-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'issue',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2,
		},
	},

	// Uncertainty
	'uncertainty-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'uncertainty',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.1,
		},
	},
	'uncertainty-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'uncertainty',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.1,
		},
	},

	// Dashboard
	'dashboard-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'dashboard',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},
	'dashboard-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'dashboard',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},

	// Starting Vehicle
	'starting-vehicle-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'starting-vehicle',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},
	'starting-vehicle-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'starting-vehicle',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},

	// Control Loss
	'control-loss-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'control-loss',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},
	'control-loss-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'control-loss',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},

	// Noises Abnormal
	'noises-abnormal-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'noises-abnormal',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},
	'noises-abnormal-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'noises-abnormal',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.2,
		},
	},

	// Symbol
	'symbol-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'symbol',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.3,
		},
	},
	'symbol-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'symbol',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.3,
		},
	},

	// Extra Info
	'extra-info-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'extra-info',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.3,
		},
	},
	'extra-info-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'extra-info',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.3,
		},
	},

	// Chose Dealer
	'dealer-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'dealer',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 3,
		},
	},
	'dealer-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'dealer',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 3,
			dealerID: '',
			dealerName: '',
		},
	},
	'quote-contact': {
		event: 'tool-complete',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'contact',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 4,
			dealerID: '',
			dealerName: '',
		},
	},

	// Result
	'result-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'result',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 3,
		},
	},
	'result-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'result',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 3,
		},
	},

	// Contact
	'contact-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'contact',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 4,
		},
	},

	// Vehicle Info
	'vehicle-info-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'vehicle-info',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 4,
		},
	},
	'vehicle-info-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'vehicle-info',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 4,
		},
	},

	// Date picker
	'date-picker-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'date-picker',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 5,
		},
	},
	'date-picker-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'date-picker',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 5,
		},
	},

	// Personal info
	'personal-info-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'personal-info',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 6,
		},
	},
	'personal-info-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'personal-info',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 6,
		},
	},

	// Validation
	'validation-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'validation',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 7,
		},
	},
	'validation-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'validation',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 7,
			dealerID: '',
			dealerName: '',
		},
	},

	// Thank you
	'thank-you-start': {
		event: 'tool-complete',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'thank-you',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 8,
			dealerID: '',
			dealerName: '',
		},
	},

	// AI Upload Start
	'ai-upload-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'dashboard-ai-upload',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.3,
		},
	},
	'ai-upload-submit': {
		event: 'tool-submit',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'dashboard-ai-upload',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.3,
		},
	},
	'ai-upload-validation-start': {
		event: 'tool-start',
		info: {
			toolType: 'request-form',
			toolName: 'wonderservice-quote',
			toolStep: 'dashboard-ai-validation',
			leadID: '',
			requestType: 'quote',
			toolStepOption: '',
			toolStepNumber: 2.4,
		},
	},
    'ai-upload-validation-submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'dashboard-ai-validation',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 2.4,
        },
    },
    'ai-upload-validation-error-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'dashboard-ai-error',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 2.5,
        },
    },
    'ai-upload-validation-confirmation-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'dashboard-ai-confirmation',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 2.5,
        },
    },
    'ai-upload-validation-confirmation-submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'dashboard-ai-confirmation',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 2.5,
        },
    },
    'ai-upload-validation-confirmation-result-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'dashboard-ai-result',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 2.6,
        },
    },
    'ai-upload-validation-confirmation-result-submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'dashboard-ai-result',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 2.6,
        },
    },

    // Vin
    'ai-vehicle-information-ai-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
        },
    },
    'ai-vehicle-information-ai-submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
        },
    },
    'ai-vehicle-information-ai-upload-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai-upload',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
        },
    },
    'ai-vehicle-information-ai-upload-submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai-upload',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
        },
    },
    'ai-vehicle-information-ai-upload-validation-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai-validation',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
        },
    },
    'ai-vehicle-information-ai-upload-validation-submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai-validation',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 4.3,
        },
    },
    'ai-vehicle-information-ai-upload-validation-error-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai-error',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
        },
    },
    'ai-vehicle-information-ai-upload-validation-confirmation-start': {
        event: 'tool-start',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai-confirmation',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
        },
    },
    'ai-vehicle-information-ai-upload-validation-confirmation-submit': {
        event: 'tool-submit',
        info: {
            toolType: 'request-form',
            toolName: 'wonderservice-quote',
            toolStep: 'vin-ai-confirmation',
            leadID: '',
            requestType: 'quote',
            toolStepOption: '',
            toolStepNumber: 4.4,
        },
    },
};

const impressionSteps = {
    'qt-start': {
        subSectionOne: '',
        pageName: 'wonderservice/quote',
    },
    'issue-start': {
        subSectionOne: 'issue',
        pageName: 'wonderservice/quote/issue',
    },
    'urgency-dealer': {
        subSectionOne: 'urgency',
        subSectionTwo: 'dealer',
        pageName: 'wonderservice/quote/urgency/dealer',
    },
    'urgency-contact': {
        subSectionOne: 'urgency',
        subSectionTwo: 'contact',
        pageName: 'wonderservice/quote/urgency/contact',
    },
    'uncertainty-dealer': {
        subSectionOne: 'uncertainty',
        subSectionTwo: 'dealer',
        pageName: 'wonderservice/quote/uncertainty/dealer',
    },
    'uncertainty-start': {
        subSectionOne: 'uncertainty',
        pageName: 'wonderservice/quote/uncertainty',
    },
    'dashboard-start': {
        subSectionOne: 'dashboard',
        pageName: 'wonderservice/quote/dashboard',
    },
    'red-symbol': {
        subSectionOne: 'red-symbol',
        pageName: 'wonderservice/quote/red-symbol',
    },
    'orange-symbol': {
        subSectionOne: 'orange-symbol',
        pageName: 'wonderservice/quote/orange-symbol',
    },
    'starting-vehicle-start': {
        subSectionOne: 'starting-vehicle',
        pageName: 'wonderservice/quote/starting-vehicle',
    },
    'control-loss-start': {
        subSectionOne: 'control-loss',
        pageName: 'wonderservice/quote/control-loss',
    },
    'noises': {
        subSectionOne: 'noises',
        pageName: 'wonderservice/quote/noises',
    },
    'technical-control': {
        subSectionOne: 'technical-control',
        pageName: 'wonderservice/quote/technical-control',
    },
    'specific-request': {
        subSectionOne: 'specific-request',
        pageName: 'wonderservice/quote/specific-request',
    },
    'extra-info-start': {
        subSectionOne: 'extra-info',
        pageName: 'wonderservice/quote/extra-info',
    },
    'result-start': {
        subSectionOne: 'result',
        pageName: 'wonderservice/quote/result',
    },
    'vehicle-info-start': {
        subSectionOne: 'vehicle-info',
        pageName: 'wonderservice/quote/vehicle-info',
    },
    // 'dealer-start': {
    //     subSectionOne: 'dealer',
    //     pageName: 'wonderservice/quote/dealer',
    // },
    'dealer-impression': {
        subSectionOne: 'dealer',
        pageName: 'wonderservice/quote/dealer',
    },
    'date-picker-start': {
        subSectionOne: 'date-picker',
        pageName: 'wonderservice/quote/date-picker',
    },
    'personal-info-start': {
        subSectionOne: 'personal-info',
        pageName: 'wonderservice/quote/personal-info',
    },
    'validation-start': {
        subSectionOne: 'validation',
        pageName: 'wonderservice/quote/validation',
    },
    'thank-you-start': {
        subSectionOne: 'thank-you',
        pageName: 'wonderservice/quote/thank-you',
    },
    'incomplete': {
        subSectionOne: 'incomplete',
        pageName: 'wonderservice/quote/incomplete',
    },
    // 'contact-start': {
    //     subSectionOne: 'uncertainty',
    //     subSectionTwo: 'contact',
    //     pageName: 'wonderservice/quote/uncertainty/contact',
    // },
};

export function handleImpressions(step) {
    let analytics = analyticstracker();
    let previousTrackingObject = JSON.parse(sessionStorage.getItem('trackingObject'));
    let currentTrackingObject = JSON.parse(document.querySelector('body').dataset.trackingInfo);
    let initialReferrer = sessionStorage.getItem('initialReferrer');

    if (!initialReferrer && document.referrer.indexOf(window.location.hostname) === -1) {
        sessionStorage.setItem('initialReferrer', document.referrer);
        initialReferrer = document.referrer;
        currentTrackingObject.initialReferrer = initialReferrer;
    }

    if (previousTrackingObject) {
        let previousPageObject = String(previousTrackingObject.pageUrl).split('?')[0];
        let previousPage = String(document.referrer).split('?')[0];
        let currentPage = String(window.location.href).split('?')[0];

        if (currentPage !== previousPage && previousPage === previousPageObject) {
            currentTrackingObject.previousPageFullUrl = previousTrackingObject.pageFullUrl;
            currentTrackingObject.previousPageName = previousTrackingObject.pageName;
            currentTrackingObject.previousPageType = previousTrackingObject.pageType;
            currentTrackingObject.previousPageUrl = previousTrackingObject.pageUrl;
            currentTrackingObject.previousPlatform = previousTrackingObject.platform;
            currentTrackingObject.previousBrand = previousTrackingObject.brand;
            currentTrackingObject.previousDealerID = previousTrackingObject.dealerID;
            currentTrackingObject.previousPageViewMode = previousTrackingObject.pageviewMode;
            currentTrackingObject.initialReferrer = initialReferrer;
        }

        if (impressionSteps[step]) {
            let subSectionOne = impressionSteps[step].subSectionOne;
            let subSectionTwo = impressionSteps[step].subSectionTwo;
            let pageName = impressionSteps[step].pageName;

            if (subSectionOne) {
                currentTrackingObject.subSectionOne = subSectionOne;
            }

            if (subSectionTwo) {
                currentTrackingObject.subSectionTwo = subSectionTwo;
            }

            if (pageName) {
                currentTrackingObject.pageName = pageName;
            }

            currentTrackingObject.section = 'quote';
        }

        document.querySelector('body').dataset.trackingInfo = JSON.stringify(currentTrackingObject);
        sessionStorage.setItem('trackingObject', document.querySelector('body').dataset.trackingInfo);
    } else {
        document.querySelector('body').dataset.trackingInfo = JSON.stringify(currentTrackingObject);
        sessionStorage.setItem('trackingObject', document.querySelector('body').dataset.trackingInfo);
    }

    analytics.trackImpression('page-impression');
}
